<template>
  <div style="background-color: white; min-height: 100vh">
    <Header />
    <div class="page-wrap">
      <v-breadcrumbs
        divider="/"
        :items="breadcrumbs"
        class="breadcrumbs"
      ></v-breadcrumbs>
      <div class="topCon">
        <div style="display: flex; align-items: flex-start">
          <v-icon id="backArrow" v-on:click="goBack()">mdi-arrow-left</v-icon>
          <div>
            <h4 class="date-head">{{ displayMonth }} {{ displayDay }}</h4>
            <p id="date-sub">Price is per vehicle up to 8 occupants</p>
          </div>
        </div>
        <v-card class="greenCard" @click="scroll()">
          <img
            style="margin: 16px"
            src="../../../assets/images/Glasses.svg"
            alt=""
            id="glassesBig"
          />
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-right: 16px;
            "
          >
            <p id="glass-head">View the Lightshow in 3D!</p>
            <p id="glass-sub">Purchase 3D glasses here</p>
          </div>
        </v-card>
      </div>

      <div id="shopifyCollectionWrap" class="shopifyCollectionWrap">
        <div ref="findGlassesOnPage" id="findGlassesOnPage"></div>
        <div
          id="collection-component-1616176464282"
          class="collectionDiv"
        ></div>
      </div>

      <v-divider class="divider" />

      <div class="passContainer2">
        <div class="infoMargin">
          <p class="passTitle">Pass Information</p>
          <div class="passContainer">
            <img
              class="noMarginimg"
              src="../../../assets/images/sun-thur-cal.svg"
            />
            <div class="iconMargin">
              <p>$15</p>
              <div class="eventTitle" id="nomargin">Sun - Thurs</div>
              <p>Per vehicle up to 8 occupants</p>
            </div>
          </div>
          <div class="passContainer">
            <img
              class="noMarginimg"
              src="../../../assets/images/fir-sat-cal.svg"
            />
            <div class="iconMargin">
              <p>$20</p>
              <div class="eventTitle" id="nomargin">Fri & Sat</div>
              <p>Per vehicle up to 8 occupants</p>
            </div>
          </div>
          <div class="passContainer">
            <img
              class="noMarginimg"
              src="../../../assets/images/dec16-24-cal.svg"
            />
            <div class="iconMargin">
              <p>$20</p>
              <div class="eventTitle" id="nomargin">Dec 16 - Dec 24</div>
              <p>Per vehicle up to 8 occupants</p>
            </div>
          </div>
          <div class="passContainer">
            <img
              class="noMarginimg"
              src="../../../assets/images/dec16-24-cal.svg"
            />
            <div class="iconMargin">
              <p>$15</p>
              <div class="eventTitle" id="nomargin">Dec 26 - Dec 30</div>
              <p>Per vehicle up to 8 occupants</p>
            </div>
          </div>
          <div class="passContainer" id="nomargin">
            <img
              class="noMarginimg"
              src="../../../assets/images/3dglasses.svg"
            />
            <div class="iconMargin">
              <p>$2 each or 3 for $5</p>
              <div class="eventTitle" id="nomargin">3D Glasses</div>
              <p class="link" v-on:click="gotoGlasses()">
                Purchase 3D glasses here
              </p>
            </div>
          </div>
        </div>

        <div class="infoMargin2">
          <p class="passTitle">Event Information</p>
          <div class="passContainer">
            <img src="../../../assets/images/dates.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Dates</div>
              <p>November 25th - December 30th <br />Closed Christmas Day</p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/time.svg" />
            <div class="iconMargin">
              <div class="eventTitle">Time</div>
              <p>Nov 25 - Dec 24: 5:00 p.m. - 10:00 p.m.</p>
              <p>Dec 26 - 30: 5:00 p.m. - 9:00 p.m.</p>
            </div>
          </div>
          <div class="passContainer">
            <img src="../../../assets/images/Disclaimer.svg" />
            <div class="iconMargin">
              <div class="eventTitle">
                Annual, Senior, and Honor Passes are not accepted for this
                event.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://sdks.shopifycdn.com/js-buy-sdk/v2/latest/index.umd.min.js"></script>
<script src="https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js"></script>
<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>

<script>
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "Fantasy at the Bay",
  metaInfo: {
    title: "Fantasy at the Bay",
    meta: [
      {
        name: "description",
        content: "Purchase your day use pass for Fantasy at the Bay Event.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      collectionId: "",
      month: this.$route.params.month,
      day: this.$route.params.day,
      displayMonth: "",
      displayDay: "",
    };
  },
  created() {
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Willard Bay State Park",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      {
        text: "Fantasy at the Bay Lights",
        disabled: false,
        href: "/parks/UTWILL/fantasyatthebay",
      },
      {
        text: "Date",
        disabled: true,
        href:
          "/parks/UTWILL/fantasyatthebay/" +
          this.$route.params.month +
          "/" +
          this.$route.params.day,
      },
    ];
  },
  mounted() {
    const header = document.getElementById("header");
    if (header) {
      header.scrollIntoView();
    }
    console.log("day", this.day);
    console.log(this.month);
    if (this.month == "December") {
      this.displayMonth = "December";
      if (this.day == "1") {
        this.displayDay = "1st";
        this.collectionId = "415648678110";
      } else if (this.day == "2") {
        this.displayDay = "2nd";
        this.collectionId = "415649628382";
      } else if (this.day == "3") {
        this.displayDay = "3rd";
        this.collectionId = "415649759454";
      } else if (this.day == "4") {
        this.displayDay = "4th";
        this.collectionId = "415649792222";
      } else if (this.day == "5") {
        this.displayDay = "5th";
        this.collectionId = "415649890526";
      } else if (this.day == "6") {
        this.displayDay = "6th";
        this.collectionId = "415649923294";
      } else if (this.day == "7") {
        this.displayDay = "7th";
        this.collectionId = "415650021598";
      } else if (this.day == "8") {
        this.displayDay = "8th";
        this.collectionId = "415650087134";
      } else if (this.day == "9") {
        this.displayDay = "9th";
        this.collectionId = "415650218206";
      } else if (this.day == "10") {
        this.displayDay = "10th";
        this.collectionId = "415650316510";
      } else if (this.day == "11") {
        this.displayDay = "11th";
        this.collectionId = "415650414814";
      } else if (this.day == "12") {
        this.displayDay = "12th";
        this.collectionId = "415650480350";
      } else if (this.day == "13") {
        this.displayDay = "13th";
        this.collectionId = "415650578654";
      } else if (this.day == "14") {
        this.displayDay = "14th";
        this.collectionId = "415650742494";
      } else if (this.day == "15") {
        this.displayDay = "15th";
        this.collectionId = "415650775262";
      } else if (this.day == "16") {
        this.displayDay = "16th";
        this.collectionId = "415650840798";
      } else if (this.day == "17") {
        this.displayDay = "17th";
        this.collectionId = "415650906334";
      } else if (this.day == "18") {
        this.displayDay = "18th";
        this.collectionId = "415650939102";
      } else if (this.day == "19") {
        this.displayDay = "19th";
        this.collectionId = "415651004638";
      } else if (this.day == "20") {
        this.displayDay = "20th";
        this.collectionId = "415651037406";
      } else if (this.day == "21") {
        this.displayDay = "21st";
        this.collectionId = "415651102942";
      } else if (this.day == "22") {
        this.displayDay = "22nd";
        this.collectionId = "415651135710";
      } else if (this.day == "23") {
        this.displayDay = "23rd";
        this.collectionId = "415651201246";
      } else if (this.day == "24") {
        this.displayDay = "24th";
        this.collectionId = "415651234014";
      } else if (this.day == "26") {
        this.displayDay = "26th";
        this.collectionId = "415651332318";
      } else if (this.day == "27") {
        this.displayDay = "27th";
        this.collectionId = "415651397854";
      } else if (this.day == "28") {
        this.displayDay = "28th";
        this.collectionId = "415651463390";
      } else if (this.day == "29") {
        this.displayDay = "29th";
        this.collectionId = "415651496158";
      } else if (this.day == "30") {
        this.displayDay = "30th";
        this.collectionId = "415651561694";
      } else {
        console.log("error in date");
      }
    } else if (this.month == "November") {
      this.displayMonth = "November";
      if (this.day == "25") {
        this.displayDay = "25th";
        this.collectionId = "415651627230";
      } else if (this.day == "26") {
        this.displayDay = "26th";
        this.collectionId = "415651659998";
      } else if (this.day == "27") {
        this.displayDay = "27th";
        this.collectionId = "415651692766";
      } else if (this.day == "28") {
        this.displayDay = "28th";
        this.collectionId = "415651758302";
      } else if (this.day == "29") {
        this.displayDay = "29th";
        this.collectionId = "415651823838";
      } else if (this.day == "30") {
        this.displayDay = "30th";
        this.collectionId = "415651889374";
      } else {
        console.log("error in date");
      }
    } else {
      console.log("error in date");
    }
    console.log(this.collectionId);
    this.loadShopifyCollection();
  },
  methods: {
    scroll: function () {
      this.$refs.findGlassesOnPage.scrollIntoView({ behavior: "smooth" });
    },
    loadShopifyCollection: function () {
      if (window.Evey) {
        if (window.Evey.buy_button) {
          $(document).ready(() => {
            this.EveyShopifyBuyInit();
          });
        } else {
          this.loadScript();
        }
      } else {
        this.loadScript();
      }
    },
    goBack() {
      this.$router.push("/parks/UTWILL/fantasyatthebay");
    },
    gotoGlasses() {
      console.log("here!");
      this.$router.push("/parks/utwill/3dglasses");
    },
    loadScript: function () {
      var scriptURL =
        "https://evey-files.s3.amazonaws.com/js/evey_buy_button.js";
      var script = document.createElement("script");
      script.async = true;
      script.src = scriptURL;
      (
        document.getElementsByTagName("head")[0] ||
        document.getElementsByTagName("body")[0]
      ).appendChild(script);
      script.onload = this.EveyShopifyBuyInit;
    },
    stopLoader: function () {
      document.getElementById("loader").style.visibility = "hidden";
    },
    EveyShopifyBuyInit: function () {
      // this.stopLoader();
      Evey.buy_button.buildShopifyBuyButton({
        shop: "parkstoreutah.myshopify.com",
        collectionId: this.collectionId,
        elementId: "collection-component-1616176464282",
        storefrontAccessToken: "1f4659f29b2004e36d6e8ebd35640005",
        collectLicensePlate: false,
        licensePlateRequired: false,
        options: {
          product: {
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "300px",
                  "margin-left": "20px",
                  "margin-bottom": "50px",
                  width: "calc(25% - 20px)",
                },
                img: {
                  height: "calc(100% - 15px)",
                  position: "absolute",
                  left: "0",
                  right: "0",
                  top: "0",
                },
                imgWrapper: {
                  "padding-top": "calc(75% + 15px)",
                  position: "relative",
                  height: "0",
                },
              },
              button: {
                ":hover": {
                  "background-color": "#87913e",
                },
                "background-color": "#96a145",
                ":focus": {
                  "background-color": "#87913e",
                },
                "border-radius": "40px",
              },
            },
            text: {
              button: "Add to cart",
            },
          },
          productSet: {
            styles: {
              products: {
                "@media (min-width: 601px)": {
                  "margin-left": "-20px",
                },
              },
            },
          },
          modalProduct: {
            contents: {
              img: false,
              imgWithCarousel: true,
              button: false,
              buttonWithQuantity: true,
            },
            styles: {
              product: {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px",
                },
              },
              button: {
                ":hover": {
                  "background-color": "#87913e",
                },
                "background-color": "#96a145",
                ":focus": {
                  "background-color": "#87913e",
                },
                "border-radius": "40px",
              },
            },
            text: {
              button: "Add to cart",
            },
          },
          option: {},
          cart: {
            styles: {
              button: {
                ":hover": {
                  "background-color": "#87913e",
                },
                "background-color": "#96a145",
                ":focus": {
                  "background-color": "#87913e",
                },
                "border-radius": "40px",
              },
            },
            text: {
              total: "Subtotal",
              button: "Checkout",
            },
          },
          toggle: {
            styles: {
              toggle: {
                "background-color": "#96a145",
                ":hover": {
                  "background-color": "#87913e",
                },
                ":focus": {
                  "background-color": "#87913e",
                },
              },
            },
          },
        },
        calendarCss: `
                    .evey-calendar-container td.selected {
                      background-color: #96A145 !important;
                    }
                    .evey-calendar-container td.selected .markers span {
                      color: #96A145 !important;
                    }
                    .evey-calendar-container td.current-day {
                      background-color: #FFFFFF !important;
                    }
                    .evey-calendar-container td.current-day .cell-date {
                      color: #9aa656 !important;
                    }
                    .evey-calendar-container .available-events .selected {
                      background-color: #96A145 !important;
                    }
                    .evey-calendar-container .modal-footer button {
                      color: #96A145;
                    }
                    .evey-calendar-container:hover .modal-footer button {
                      color: #838c41;
                      cursor: pointer;
                    }
                  `,
        triggerCss: `
                    button[data-evey-trigger="scheduler"] {
                      border: 1px solid #c2c2c2;
                      padding: 10px 30px 10px 7px;
                      width:100%;
                      text-align:left;
                      font-size:inherit;
                      display:flex;
                      align-items:center;
                      position: relative;
                    }
                    button[data-evey-trigger="scheduler"]:after {
                      content: url("data:image/svg+xml; utf8, %3Csvg%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M17.5%202H15V1a1%201%200%2010-2%200v1H6V1a1%201%200%2000-2%200v1p.5C1.7%202%201%202.7%201%203.5v15c0%20.8.7%201.5%201.5%201.5h15c.8%200%201.5-.7%201.5-1.5v-15c0-.8-.7-1.5-1.5-1.5zM3%2018h14V8H3v10z%22%20fill%3D%22%23849235%22%2F%3E%3C%2Fsvg%3E");
                      display:inline-block;
                      position:absolute;
                      right:10px;
                      padding-left: 16px;
                      width:20px;
                      height:20px;
                    }
                  `,
      });
    },
  },
};
</script>

<style scoped>
.link {
  font-size: 16px;
  font-family: "Roboto";
  color: #96a145;
  cursor: pointer;
}
#backArrow {
  padding-right: 30px;
}
#date-sub {
  font-family: "Roboto";
  font-size: 20px;
  line-height: 24px;
  padding-bottom: 20px;
}
.date-head {
  font-family: "boldRoboto";
  font-size: 36px;
  line-height: 24px;
  padding-bottom: 20px;
}
#nomargin {
  margin-top: 0px;
}
.topCon {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 100px;
}
.greenCard {
  background-color: #dde0c1 !important;
  border-radius: 8px !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 10px rgba(0, 0, 0, 0.1) !important;
  display: flex;
  flex-direction: row;
  display: none;
}

#glass-head {
  font-family: "boldRoboto";
  font-size: 20px;
  color: #000000;
}
#glass-sub {
  font-family: "Roboto";
  font-size: 16px;
  color: #000000;
}
.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38);
}
.v-breadcrumbs {
  margin: 0px 12px 18px 12px;
}
p {
  line-height: 22px;
}
.shopifyCollectionWrap {
  width: 100%;
  min-height: 300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.divider {
  margin: 24px 0px;
}
.page-wrap {
  padding: 32px;
  max-width: 1600px;
  margin: 0 auto;
}
.dateTitle {
  font-size: 24px;
  font-family: "boldRoboto";
  margin-bottom: 12px;
  /* margin-top: 44px; */
}
.passTitle {
  font-size: 24px;
  font-family: "boldRoboto";
  margin-bottom: 12px;
  margin-top: 44px;
}
.greenLink {
  color: #96a145;
  text-decoration: underline #96a145 !important;
  font-size: 16px;
  font-family: "boldRoboto";
  margin: 16px 0px;
  display: block;
  cursor: pointer;
}
.eventImg {
  width: 100%;
  max-height: 350px;
  object-fit: cover;
  object-position: bottom;
  height: auto;
  position: relative;
}
.golfImage {
  width: 330px;
  height: 198px;
  object-fit: cover;
  margin-top: 25px;
  margin-right: 25px;
  object-position: 0% 0;
}
.cloud {
  margin-right: 25px;
}
.bottom-left {
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-width: 1600px;
  padding: 32px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.eventBox p,
.eventBox li,
.eventBox li a,
.eventBox a {
  font-size: 16px;
}
.eventText {
  margin: 0px;
}
.eventTitle {
  margin-top: 16px;
  margin-bottom: 4px;
  font-family: "boldRoboto";
  font-size: 18px;
}
.shopifyContainer {
  position: relative;
  width: 100%;
  /* background-color: whitesmoke; */
  display: flex;
}
.shopifyWrap,
.shopifyWrap2 {
  display: inline-block;
  height: 100%;
  /* background-color: whitesmoke; */
  border: none;
  width: 100%;
  padding: 0px;
  margin: 0px;
}
.flexWrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.flexWrapRow {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}
.shopifyFlex {
  display: flex;
  /* background-color: whitesmoke */
}
.shopifyBox,
.shopifyBox2,
.waiverBox {
  background-color: white;
  width: auto;
  border: 1px solid #c4c4c4;
  padding: 32px;
  position: relative;
  margin-left: 0px;
}
.waiverBox {
  margin-left: 32px;
}
.shopifyBox {
  margin: 0px;
  margin-bottom: 32px;
}
.shopifyBox2 {
  margin-top: 0px;
}
.shopifyBox2 a {
  font-size: 24px;
  text-decoration: underline;
  color: #96a145;
  font-family: "mediumRoboto";
  cursor: pointer;
}
.shopify-buy__product {
  padding-top: 50px;
  max-width: calc(75% - 20px) !important;
  width: calc(75% - 20px) !important;
}
.collectionDiv {
  padding: 32px 0px;
  height: 100%;
}
.eventBox p,
.eventBox li,
.eventBox li a,
.eventBox a {
  font-size: 16px;
}
.green-btn {
  height: 42px;
  line-height: 42px;
  border-radius: 32px;
  background-color: #96a145;
  color: white;
  width: 140px;
  padding: 0px 16px;
  text-align: center;
  font-size: 16px;
  font-family: "regularRoboto";
  margin-top: 8px;
  cursor: pointer;
}
.gray-btn {
  padding: 16px;
  border-radius: 32px;
  background-color: gray;
  color: white;
  width: 200px;
  text-align: center;
  font-size: 18px;
  margin-top: 16px;
  cursor: auto;
}
.green-btn:hover {
  background-color: #818a3c;
}
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-bottom: 12px;
  margin-top: 32px;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border: 2px solid lightgray;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #96a145;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.waiverBox {
  text-align: left;
  max-width: 30%;
  align-self: baseline;
}
b {
  font-weight: bold;
}
.mobileShow {
  display: none;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145;
}

.passType {
  font-size: 24px;
  font-family: "boldRoboto";
  color: #494e53;
  margin-top: 0px;
  padding: 4px 0px;
}
.passText {
  display: inline-block;
  font-size: 16px;
  line-height: 24px;
  margin: 0px;
}
.passContainer {
  display: flex;
  margin-bottom: 16px;
  align-items: flex-start;
}
.passContainer2 {
  display: flex;
  margin: 12px 0px;
}
.buttonContainer {
  float: right;
  display: block;
  margin: 12px 16px;
  cursor: pointer;
  height: 24px;
  margin-left: auto;
}
#signUpButton {
  background: #96a145;
  border: 1px solid #96a145;
  box-sizing: border-box;
  border-radius: 48px;
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 40px;
  font-size: 16px;
  line-height: 1.2;
  display: inline-block;
  font-weight: 1000;
}
.iconMargin {
  margin-left: 14px;
}
.passMargin {
  margin-left: 34px;
}
.infoMargin {
  max-width: 50%;
}
.infoMargin2 {
  margin-left: 75px;
  max-width: 60%;
}
.price {
  text-align: center;
  display: block;
  margin: 3px;
}
.month {
  font-size: 12px;
  color: #96a145;
  text-align: center;
  line-height: 24px;
  font-family: "boldRoboto";
  /* font-weight: 1000; */
}
.day {
  font-size: 18px;
  color: #494e53;
  text-align: center;
  line-height: 24px;
  /* font-family: 'boldRoboto'; */
  font-weight: 1000;
}
a {
  text-decoration: none;
  color: #96a145;
}

.passContainer > img {
  margin-top: 16px;
}
.noMarginimg {
  margin-top: 22px !important;
}
@media only screen and (max-width: 850px) {
  .passTitle {
    margin-top: 20px;
  }
  .passContainer2 {
    display: inline;
  }
  .passContainer {
    align-items: flex-start;
  }
  .passContainer > img {
    margin-top: 15px;
  }
  .passMargin {
    margin-left: 16px;
  }
  .infoMargin {
    max-width: 100%;
    margin-left: 0px;
  }
  .infoMargin2 {
    margin-left: 0px;
    max-width: unset;
  }
  .bottom-left {
    padding: 25px;
  }
  .page-wrap {
    padding: 16px;
  }
  .mobileShow {
    display: block;
  }
  .waiverBox {
    display: none;
  }
  .shopifyContainer {
    display: block;
    padding: 8px;
    width: auto;
  }
  .shopifyWrap,
  .shopifyBox,
  .shopifyBox2 {
    margin-left: 0px;
    margin-right: 0px;
    padding: 16px;
  }
  .shopifyWrap {
    width: -webkit-fill-available;
    margin-bottom: 8px;
    margin-top: 0px;
    padding: 0px;
  }
  .flexWrap {
    width: auto;
  }
  .shopifyFlex {
    display: block;
  }
  .waiverBox {
    max-width: 100%;
    margin: 8px;
  }
  .shopifyWrap2 {
    margin-left: 0px;
  }
  .wrapLeft {
    margin: 8px;
  }
  .collectionDiv {
    padding: 0px;
  }
  .shopifyBox,
  .shopifyBox2 {
    margin: 0px 0px;
  }
  .shopifyBox2 {
    margin-top: 8px;
  }
  .passText,
  .passType {
    font-size: 16px;
  }
  .eventInfoTitle {
    font-size: 16px;
  }
  .infoBox {
    margin-top: 8px !important;
  }
  .eventBox p,
  .eventBox li,
  .eventBox li a,
  .eventBox a {
    font-size: 14px;
  }
  .eventInfoTitle {
    font-size: 22px;
    font-family: "boldRoboto";
  }
  .eventImg {
    /* filter: brightness(80%); */
    object-position: top;
    height: 450px;
  }
  .date-sub {
    margin-bottom: 0px;
  }
}
@media only screen and (max-width: 768px) {
  .topCon {
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
    align-items: stretch;
    padding-bottom: 0px;
  }

  .greenCard {
    display: flex;
    margin-bottom: 50px;
  }
  .passTitle {
    margin-top: 50px;
  }

  .date-sub {
    padding-bottom: 0px;
  }
}
@media only screen and (max-width: 425px) {
  #backArrow {
    padding-right: 15px;
  }
  #date-sub {
    font-family: "Roboto";
    font-size: 16px;
    line-height: 18px;
    padding-bottom: 0px;
  }
  .date-head {
    font-family: "boldRoboto";
    font-size: 24px;
    line-height: 24px;
    padding-bottom: 10px;
  }
}
@media only screen and (max-width: 375px) {
  #glass-head {
    font-size: 16px;
  }
  #glass-sub {
    font-size: 14px;
  }
}
@media only screen and (max-width: 320px) {
  #glassesBig {
    width: 18%;
  }
}
</style>
